export const formatRate = (rate: string | number) => `${rate}%`;
